export enum OntarioLocationCheckStatus {
  Idle,
  InProgress,
  Done,
}
